<div class="form-horizontal m-1x mb-3x mt-3x">
  <div *ngIf="showError1">
    <common-ui-card [message]=" 'COMMON_UI.FRAGEBOGEN.ORGANSCHAFTSVERHAELTNISSE.ORGANGESELLSCHAFT.ERROR1' | translate"
                    type="danger">
    </common-ui-card>
  </div>
  <div *ngIf="showError2">
    <common-ui-card [message]=" 'COMMON_UI.FRAGEBOGEN.ORGANSCHAFTSVERHAELTNISSE.ORGANGESELLSCHAFT.ERROR2' | translate"
                    type="danger">
    </common-ui-card>
  </div>
  <div class="form-row mb-3x mt-3x">
    <label class="col-sm-7"
           for="personenTyp">{{ 'COMMON_UI.FRAGEBOGEN.ORGANSCHAFTSVERHAELTNISSE.ORGANGESELLSCHAFT.PERSONENTYP_TITEL' | translate }}</label>
    <div class="col-sm-5">
      <select (change)="onPersonTypeChange()" [(ngModel)]="data.personenTyp" [disabled]="readonly" class="form-control"
              id="personenTyp">
        <option [ngValue]="undefined"
                selected>{{ 'COMMON_UI.FRAGEBOGEN.ORGANSCHAFTSVERHAELTNISSE.ORGANGESELLSCHAFT.PERSONENTYP.NULL' | translate }}</option>
        <option *ngFor="let value of enumKeys(personenTypEnum)"
                [ngValue]="personenTypEnum[value]">
          {{ 'COMMON_UI.FRAGEBOGEN.ORGANSCHAFTSVERHAELTNISSE.ORGANGESELLSCHAFT.PERSONENTYP.KEY_' + personenTypEnum[value].toUpperCase() | translate }}
        </option>
      </select>
    </div>
  </div>

  <div *ngIf="data.personenTyp" class="mb-5x">
    <common-ui-koerperschaftssteuer
      (dataChange)="onDataChanged()"
      [(data)]="data"
      [index]="index"
      [readonly]="readonly">
    </common-ui-koerperschaftssteuer>
  </div>

  <div *ngIf="data.personenTyp === personenTypEnum.NatPers" class="mb-3x">

    <h2
      class="mb-3x">{{ 'COMMON_UI.FRAGEBOGEN.ORGANSCHAFTSVERHAELTNISSE.ORGANGESELLSCHAFT.NATUERLICHE_PERSON_TITEL' | translate }}
    </h2>
    <common-ui-organtraeger-natuerliche-person (dataChange)="onDataChanged()" [(data)]="data.natuerlichePerson"
                                               [readonly]="readonly">
    </common-ui-organtraeger-natuerliche-person>
  </div>

  <div *ngIf="data.personenTyp === personenTypEnum.NNatPers" class="mb-3x">
    <h2
      class="mb-3x">{{ 'COMMON_UI.FRAGEBOGEN.ORGANSCHAFTSVERHAELTNISSE.ORGANGESELLSCHAFT.NICHT_NATUERLICHE_PERSON_TITEL' | translate }}
    </h2>
    <common-ui-organtraeger-nicht-natuerliche-person (dataChange)="onDataChanged()" [(data)]="data.juristischePerson"
                                                     [readonly]="readonly">
    </common-ui-organtraeger-nicht-natuerliche-person>
  </div>

  <div *ngIf="data.personenTyp">
    <common-ui-steuernummer
      [(data)]="data.steuernummer"
      [index]="index"
      [readonly]="readonly">
    </common-ui-steuernummer>
    <common-ui-wirtschafts-id
      *ngIf="showWirtschaftsIdNummer"
      [(data)]="data"
      [index]="index"
      [readonly]="readonly">
    </common-ui-wirtschafts-id>
    <div class="mt-3x">
      <common-ui-umsatzsteuer
        (dataChange)="onDataChanged()"
        [data]="data"
        [index]="index"
        [readonly]="readonly">
      </common-ui-umsatzsteuer>
    </div>
  </div>

</div>

